import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { UserPlus } from "lucide-react";
import API_BASE_URL from "../config/Config.js";
import GlassCard from "./ui/GlassCard";
import Button from "./ui/Button";

const inputClass =
  "w-full rounded-lg border border-dark-200 px-3 py-2.5 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500";

function Field({ label, ...props }) {
  return (
    <div>
      <label className="block mb-1 text-sm font-medium text-dark-700">{label}</label>
      <input className={inputClass} {...props} />
    </div>
  );
}

export default function RegistrationForm() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    iin: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setError("Пароли не совпадают");
      return;
    }

    if (!/^\d{12}$/.test(formData.iin)) {
      setError("ИИН должен содержать ровно 12 цифр");
      return;
    }

    setError("");

    const payload = {
      email: formData.email,
      first_name: formData.first_name,
      last_name: formData.last_name,
      password: formData.password,
      username: formData.username,
      iin: formData.iin,
    };

    try {
      await axios.post(`${API_BASE_URL}/auth/signup`, payload);
      alert("Вы успешно зарегистрировались!");
      navigate("/login");
    } catch (err) {
      console.error("Ошибка регистрации", err);
      setError("Ошибка при регистрации. Проверьте данные или повторите позже.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-24 pb-12 bg-gradient-to-br from-primary-50 via-white to-teal-50">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-3xl"
      >
        <GlassCard hover={false} className="p-8 bg-white/90">
          <div className="flex flex-col items-center mb-6">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-500 to-teal-500 flex items-center justify-center shadow-glow mb-3">
              <UserPlus className="w-7 h-7 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-dark-900">Регистрация</h2>
          </div>

          <form onSubmit={handleSubmit} className="grid md:grid-cols-2 gap-4">
            <Field
              label="Имя"
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
            />
            <Field
              label="Фамилия"
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              required
            />
            <Field
              label="Имя пользователя"
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
            <Field
              label="Электронная почта"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <Field
              label="ИИН"
              type="text"
              name="iin"
              value={formData.iin}
              onChange={handleChange}
              required
              maxLength={12}
              pattern="\d{12}"
              title="ИИН должен содержать ровно 12 цифр"
              placeholder="123456789012"
            />
            <div />
            <Field
              label="Пароль"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <Field
              label="Подтвердите пароль"
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />

            {error && (
              <div className="md:col-span-2 text-red-600 text-sm bg-red-50 rounded-lg px-3 py-2">
                {error}
              </div>
            )}

            <div className="md:col-span-2">
              <Button type="submit" variant="primary" className="w-full justify-center">
                Зарегистрироваться
              </Button>
            </div>

            <div className="md:col-span-2 text-center pt-1">
              <span className="text-sm text-dark-500">Уже есть аккаунт? </span>
              <Link to="/login" className="text-primary-600 font-semibold hover:underline">
                Войти
              </Link>
            </div>
          </form>
        </GlassCard>
      </motion.div>
    </div>
  );
}
